var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBillboardSmallMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.64 42.64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M0 0h40.64v42.64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2da343",
    d: "M4.73 4.03h31.18v8.5H4.73zM4.73 30.11h31.18v8.5H4.73zM4.73 17.07h31.18v8.5H4.73z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MC42NCA0Mi42NCI+DQogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPg0KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+DQogICAgICA8Zz4NCiAgICAgICAgPHJlY3Qgd2lkdGg9IjQwLjY0IiBoZWlnaHQ9IjQyLjY0IiBzdHlsZT0iZmlsbDogI2VkZWRlZCIvPg0KICAgICAgICA8cmVjdCB4PSI0LjczIiB5PSI0LjAzIiB3aWR0aD0iMzEuMTgiIGhlaWdodD0iOC41IiBzdHlsZT0iZmlsbDogIzJkYTM0MyIvPg0KICAgICAgICA8cmVjdCB4PSI0LjczIiB5PSIzMC4xMSIgd2lkdGg9IjMxLjE4IiBoZWlnaHQ9IjguNSIgc3R5bGU9ImZpbGw6ICMyZGEzNDMiLz4NCiAgICAgICAgPHJlY3QgeD0iNC43MyIgeT0iMTcuMDciIHdpZHRoPSIzMS4xOCIgaGVpZ2h0PSI4LjUiIHN0eWxlPSJmaWxsOiAjMmRhMzQzIi8+DQogICAgICA8L2c+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgBillboardSmallMore as ReactComponent };